import { Box, Flex, MantineTheme, Stack, Title, useMantineTheme } from '@mantine/core'
import React from 'react'

import { useAuth } from '@/plugins/auth'

import { useErrorMessages } from '../../constants/content'
import { Transfer } from '../../schemas/types'
import { StyledStack } from '../../styled/components'
import ErrorMessage from '../ErrorMessage'
import Loading from '../Loading'
import NoData from '../NoData'

interface MobileTableProps {
  dashboard?: boolean
  title: string
  data: any[] | null
  dataToRow: (
    address: `0x${string}` | string,
    transaction: Transfer,
    prevTxHash: string,
    theme: MantineTheme
  ) => JSX.Element
  loading: boolean
  error: any
  header?: JSX.Element | React.ReactNode
  headerButton?: JSX.Element | React.ReactNode
  filter?: JSX.Element | React.ReactNode
  footer?: JSX.Element | React.ReactNode
}

const MobileTable: React.FC<MobileTableProps> = ({
  dashboard = false,
  title,
  data,
  dataToRow,
  loading,
  error,
  header,
  headerButton,
  filter,
  footer,
}) => {
  const theme = useMantineTheme()
  const { address } = useAuth()
  const errorMessages = useErrorMessages()
  return (
    <StyledStack style={{ gap: dashboard ? '4px' : '16px' }}>
      <Stack
        style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}
      >
        <Stack style={{ flexDirection: 'row', alignItems: 'center' }}>
          <Title order={4}>{title}</Title>
          <Box>{headerButton}</Box>
        </Stack>
        {filter}
      </Stack>
      {header}
      {!error && (
        <Flex direction="column" gap="10px">
          <Stack style={{ minHeight: '600px' }}>
            {!loading ? (
              data && data.length > 0 ? (
                <Stack>
                  {data.map((elem, index) =>
                    dataToRow(
                      address?.toLocaleLowerCase() || '',
                      elem,
                      index > 0 ? data[index - 1].txnHash : '',
                      theme
                    )
                  )}
                </Stack>
              ) : (
                !error && <NoData missing="activity" />
              )
            ) : (
              <Loading />
            )}
          </Stack>
          <Stack style={{ alignItems: 'center' }}>{footer}</Stack>
        </Flex>
      )}
      {error && <ErrorMessage message={errorMessages.indexerConnection} details={error.message} />}
    </StyledStack>
  )
}

export default MobileTable
